<!--拼团分享-->
<template>
  <div>
    <div class="goods">
      <img class="goods-img" :src='row.pic_url' alt="">
      <div class="goods-detail">
        <div class="goods-name">{{row.title}}</div>
        <div class="goods-num">仅剩<span>{{order.total_member_count-order.member_count}}</span>个名额</div>
        <div class="price-box">
          <div class="goods-price">
            <span>¥</span>{{row.price}}
          </div>
          <div class="goods-pri-thr gray-light">
            ¥{{row.goods_price}}
          </div>
        </div>
      </div>
    </div>
    <div class="border-top invite">
      <div class="invite-user" v-if="order.status==1">
        <div class="invite-user-box" v-for="(item, index) in member_list">
          <img class="user-img" :src="item.face" alt="">
          <span class="user-tip" v-if="item.is_leader>0">团长</span>
        </div>
        <div class="user-empity">
          ?
        </div>
      </div>

      <div v-if="is_joined">
        <div class="djs-box" @click="goShare" v-if="order.status==1">
          <div style="display: flex;">
            <div>邀请好友</div>
            <van-count-down :time="(order.last_time+1)*1000">
              <template v-slot="timeData">
                <span class="item">{{ timeData.days }}</span>天
                <span class="item">{{ timeData.hours }}</span> :
                <span class="item">{{ timeData.minutes }}</span> :
                <span class="item">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
            <div>结束</div>
          </div>
        </div>
        <div class="share-text gray-light" v-if="order.status==1">分享给微信好友，成团高达98%</div>
        <div class="share-text gray-light" v-else-if="order.status==2">
          已完成
          <div @click="goHome" class="invite-btn">返回首页</div>
        </div>
        <div class="share-text gray-light" v-else-if="order.status==3">
          已过期
          <div @click="goHome" class="invite-btn">返回首页</div>
        </div>

        <div class="share-text gray-light" v-else-if="order.status==4">
          未支付
          <div @click="goHome" class="invite-btn">返回首页</div>
        </div>
      </div>

      <div v-else>
        <div class="djs-box" @click="skuSelect" v-if="order.status==1">
          <div style="display: flex;">
            <div>我要参加</div>
            <van-count-down :time="(order.last_time+1)*1000">
              <template v-slot="timeData">
                <span class="item">{{ timeData.days }}</span>天
                <span class="item">{{ timeData.hours }}</span> :
                <span class="item">{{ timeData.minutes }}</span> :
                <span class="item">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
            <div>结束</div>
          </div>
        </div>
        <div class="share-text gray-light" v-if="order.status==1">参加拼团，享优惠</div>
        <div class="share-text gray-light" v-else-if="order.status==2">
          已完成
          <div @click="goHome" class="invite-btn">返回首页</div>
        </div>
        <div class="share-text gray-light" v-else-if="order.status==3">
          已过期
          <div @click="goHome" class="invite-btn">返回首页</div>
        </div>

        <div class="share-text gray-light" v-else-if="order.status==4">
          未支付
          <div @click="goHome" class="invite-btn">返回首页</div>
        </div>
      </div>
    </div>
    <div class="tips-box border-top">
      <div class="row-between">
        <div class="row-left">拼团时间</div>
        <div class="row-right">
          {{order.time_start_str}}
        </div>
      </div>
      <div class="row-between no-border">
        <div class="row-left">拼团须知</div>
        <div class="row-right">
          ·好友参团 ·人满发货 ·不满退款
        </div>
      </div>
    </div>

    <div class="detail-title">
      <div></div>
      <span>商品详情</span>
      <div></div>
    </div>
    <div class="detail-img" v-html="row.content"></div>


    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    <div class="shareShow" v-if="showWxShare" @click="cancleShare">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>
    <div class="sku-container">
      <van-sku
        v-model="showSkuPicker"
        :sku="skuData.sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        @buy-clicked="toBuy"
      >
        <template slot="sku-actions" slot-scope="props">
          <div class="van-sku-actions">
            <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
            <van-button
              square
              size="large"
              type="warning"
              @click="props.skuEventBus.$emit('sku:buy')"
            >
              立即购买
            </van-button>
          </div>
        </template>
      </van-sku>
    </div>

  </div>
</template>
<style scoped>
  @import '../../../assets/style/activity.css';

  .detail-title {
    width: 7.5rem;
    line-height: 0.5rem;
    height: 0.5rem;
    background: rgba(239, 239, 239, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .detail-title div {
    width: 0.62rem;
    height: 1px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.08;
  }

  .detail-title span {
    margin: 0 0.2rem;
  }

  .detail-img >>> img {
    width: 100%;
    /*margin-bottom: 50px;*/
  }

  .van-count-down {
    color: #fff;
    line-height: 37.5px;
    font-size: 15px;
    display: flex;
  }

  .border-top {
    border-top: 0.1rem solid #EFEFEF;
  }

  .goods {
    padding: 0.3rem;
    display: flex;
    justify-content: flex-start;
  }

  .goods-img {
    width: 2.76rem;
    height: 2.76rem;
    border-radius: 5px;
  }

  .goods-detail {
    width: 4rem;
    margin-left: 0.2rem;
  }

  .goods-name {
    font-size: 15px;
  }

  .goods-num {
    font-weight: 500;
    margin: 0.1rem 0;
  }

  .goods-num span {
    color: #FF2339;
  }

  .price-box {
    margin-top: 0.3rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
  }

  .goods-price {
    color: #FD2840;
    font-size: 16px;
  }

  .goods-pri-thr {
    text-decoration: line-through;
    margin-left: 0.2rem;
    margin-top: 0.1rem;
  }

  .invite-user {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.2rem 0;
  }

  .invite-user-box {
    border: 1px solid rgba(253, 40, 64, 1);
    width: 0.82rem;
    height: 0.82rem;
    border-radius: 100%;
    position: relative;
    margin-left: 0.2rem;
  }


  .invite-btn {
    width: 280px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    color: #fff;
    font-size: 15px;
    background: rgba(253, 40, 64, 1);
    border-radius: 5px;
    margin: 15px auto;
  }

  .user-empity {
    border: 1px dashed rgba(253, 40, 64, 1);
    width: 0.82rem;
    height: 0.82rem;
    border-radius: 100%;
    position: relative;
    line-height: 0.82rem;
    text-align: center;
    color: #FD2840;
    margin-left: 0.2rem;
  }

  .user-tip {
    font-size: 10px;
    color: #fff;
    background: #FD2840;
    border-radius: 7px;
    position: absolute;
    right: -0.1rem;
    bottom: -0.1rem;
    padding: 0 2px;
  }

  .user-img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }

  .djs-box {
    width: 5.6rem;
    height: 0.75rem;
    line-height: 0.75rem;
    text-align: center;
    background: rgba(253, 40, 64, 1);
    border-radius: 0.1rem;
    color: #fff;
    font-size: 15px;
    margin: 0.1rem auto;
    display: flex;
    justify-content: center;
  }

  .share-text {
    font-size: 11px;
    text-align: center;
    margin: 0.2rem 0 0.4rem 0;
  }

  .tips-box {
    padding: 0 0.31rem;
    font-size: 12px;
    color: #181818;
  }

  .row-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #EFEFEF;
    padding: 0.3rem 0;
  }

  .row-right {
    color: #333333;
  }

  .row-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .no-border {
    border: none;
  }
</style>

<script>
    import Vue from 'vue'
    import {
        Sku,CountDown
    } from 'vant';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Sku).use(CountDown);

    export default {
        name: 'TuanShare',
        components: {
            LoginDialog
        },
        data: function () {
            return {
                showGoodsSkuPicker: false,
                showSkuPicker: false,
                closeOnClickOverlay: true,
                messageConfig: {},
                showWxShare: false,
                row: {
                    pic: '',
                    price: '-',
                    goods_price: '-',
                    title: '-'
                },
                order: {
                    total_member_count: 0,
                    member_count: 0,
                    status: 0
                },
                is_joined: false,
                member_list: [],
                loginShow: false,
                skuData: {
                    sku: {
                        none_sku: false,  // 是否无规格商品
                        hide_stock: false,  // 是否隐藏剩余库存
                        list: [],
                        tree: []
                    },
                    goods: {},
                    goods_id: 0,
                },
                timeData: {
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    milliseconds: 0,
                },
            }
        },
        filter: {},
        mounted() {
            document.title = '拼团详情';
            this.getTuanDetail()
            this.lastTimeRun();
        },
        destroyed() {
        },
        methods: {
            getTuanDetail() {
                let that = this;
                let id = this.$route.query.id;
                let sku = {};
                let total = 0;

                this.$api.get('/api/tuan/sharedetail', {id: id}, (res) => {
                    // console.log(res)
                    that.row = res.data.data
                    that.order = res.data.order
                    that.is_joined = res.data.is_joined
                    that.member_list = res.data.member_list

                    that.skuData.sku = sku = res.data.sku
                    that.skuData.sku.messages = []

                    that.skuData.goods = {
                        title: that.row.title,
                        picture: that.row.pic_url
                    }

                    // 总数量
                    for (let i = 0; i < sku.list.length; i++) {
                        total = total + sku.list[i].stock_num
                    }

                    that.skuData.sku.stock_num = total;
                    that.skuData.sku.price = that.row.price / 100;
                    that.skuData.goods_id = that.row.goods_id;

                    that.wxShare(res.data.share.title, res.data.share.desc, res.data.share.url, res.data.share.pic_url);

                })
            },

            lastTimeRun() {
                let that = this;
                let lastTime_t_handle = setInterval(() => {
                    that.timeData = that.lastTime(that.order.last_time)

                    if (that.order.last_time == 0) {
                        clearInterval(lastTime_t_handle);
                        return;
                    }
                    that.order.last_time -= 1
                }, 1000)

            },

            skuSelect() {
                let that = this;
                that.showSkuPicker = true;
            },

            // 立即购买
            toBuy(data) {
                let that = this;

                let goods_items = [{
                    goods_id: data.goodsId,
                    sku_id: data.selectedSkuComb.id,
                    count: data.selectedNum,
                }];

                // 存入缓存
                localStorage.setItem("tuan_order_check_goods_items", JSON.stringify(goods_items))
                localStorage.setItem("tuan_order_id", that.order.id)

                let url = '/tuanordercheck'
                if (that.row.goods_type == 'shop') {
                    url = '/shoptuanordercheck';
                }
                this.$router.push({
                    path: url
                })
            },

            goShare() {
                this.showWxShare = true;
            },

            cancleShare() {
                this.showWxShare = false
            },

            goHome() {
                this.$router.push({
                    path: '/self/index',
                    query: {
                        business_id: this.row.business_id
                    }
                })
            },

            loginSuccess(res) {
                console.log('-------登录成功--------', res);
                this.loginShow = false;
                this.getTuanDetail()
            },

            loginCancel() {
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// TuanShare.vue?6b2d7c00